module.exports = __webpack_public_path__ + "699aa6c30bc6d40c00a81d6d993f24d8.jpg";